SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_main_content')

module.exports = class MainContentComponent extends React.Component
  render: t.renderable ->
    t.div '.enterprise-dash-layout', =>
      t.div '.enterprise-dash-layout-sidebar', =>
        t.div '.js-sidebar-content'

      t.div '.enterprise-dash-layout-list', =>
        t.div '.indented-title.u-clearfix', =>
          t.div '.js-list-header-content .list-header'

          t.addElement React.createElement SearchComponent,
            onChange: @props.onSearchTermChange
            clearValue: @props.clearSearchValue
            placeholder: t.l(['search', @props.selectedTab])
            debounce: true

        t.div '.js-filters-content'
        t.div '.js-bulk-actions-content'
        t.div '.js-list-content.enterprise-dash-list'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/main-content-component.coffee